// =============================================================================
// Account Footer - Barra account per le pagine fuori dalla AppShell
// =============================================================================
// Select-tenant e onboarding vivono fuori dal guscio dell'app: senza sidebar,
// profilo e lingua non sarebbero raggiungibili da chi non ha ancora scelto (o
// creato) un'organizzazione. Questa barra li riporta accanto al logout.
// =============================================================================

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, User } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { LanguageSelector } from './LanguageSelector';

export interface AccountFooterProps {
  onLogout: () => void;
}

export function AccountFooter({ onLogout }: AccountFooterProps) {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const user = useAuthStore((s) => s.user);

  return (
    <div className="mt-6 bg-white/70 backdrop-blur-sm border border-gray-200 rounded-xl p-2.5 flex items-center gap-2">
      <Link
        to="/profile"
        title={t('profile.title')}
        className="flex items-center gap-2.5 min-w-0 flex-1 rounded-lg p-1 -m-1 hover:bg-gray-50 transition-colors"
      >
        <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
          <User className="w-4 h-4 text-gray-500" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {user?.firstName} {user?.lastName}
          </p>
          <p className="text-xs text-gray-500 truncate">{user?.email}</p>
        </div>
      </Link>

      <LanguageSelector />

      <button
        onClick={onLogout}
        title={tCommon('nav.logout')}
        className="flex items-center gap-1.5 px-2.5 py-2 text-sm font-medium text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
      >
        <LogOut className="w-4 h-4" />
        <span className="hidden sm:inline">{tCommon('nav.logout')}</span>
      </button>
    </div>
  );
}

export default AccountFooter;
